<div class="icon-picker">
  <label class="form-label" *ngIf="label">{{ label }}</label>

  <div class="picker-row">
    <div class="icon-preview" [class.invalid]="value && !allIcons.includes(value)" title="Pré-visualização">
      <nb-icon [icon]="previewIcon"></nb-icon>
    </div>

    <div class="picker-input">
      <nb-form-field>
        <nb-icon nbPrefix [icon]="previewIcon"></nb-icon>
        <input
          nbInput
          type="text"
          [ngModel]="value"
          (ngModelChange)="onInputChange($event)"
          [placeholder]="placeholder"
          fullWidth />
      </nb-form-field>
    </div>

    <button
      type="button"
      nbButton
      status="primary"
      outline
      class="picker-toggle"
      (click)="togglePicker()"
      [title]="pickerOpen ? 'Fechar seletor' : 'Abrir seletor de ícones'">
      <nb-icon [icon]="pickerOpen ? 'close-outline' : 'grid-outline'"></nb-icon>
    </button>
  </div>

  <div class="picker-panel" *ngIf="pickerOpen">
    <nb-form-field>
      <nb-icon nbPrefix icon="search-outline"></nb-icon>
      <input
        nbInput
        type="text"
        [(ngModel)]="search"
        (ngModelChange)="filterIcons()"
        placeholder="Buscar ícone..."
        fullWidth />
    </nb-form-field>

    <p class="picker-hint" *ngIf="filteredIcons.length === 0">Nenhum ícone encontrado.</p>

    <div class="icons-grid">
      <button
        type="button"
        class="icon-option"
        *ngFor="let icon of filteredIcons"
        [class.selected]="icon === value"
        (click)="selectIcon(icon)"
        [title]="icon">
        <nb-icon [icon]="icon"></nb-icon>
        <span class="icon-name">{{ icon.replace('-outline', '') }}</span>
      </button>
    </div>
  </div>
</div>
